import styled, { css } from 'styled-components'

import { mobileFontSizes } from './helpers/size'

export const StyledText = styled.span`
    ${props => {
        const { color, css: customCss } = props
        const size = mobileFontSizes[props.level]
        const unit = mobileFontSizes.unit
        const fontSize = `${size}${unit}`
        const fontFamily = props.bold ? 'AvenirBold' : 'Avenir'

        return css`
            color: ${color};
            font-size: ${fontSize};
            font-family: ${fontFamily};
            cursor: inherit;
            ${customCss}
        `
    }}
`
